// src/aws-exports.js
const awsmobile = {
    aws_project_region: 'ap-southeast-2',
    aws_cognito_region: 'ap-southeast-2',
    aws_user_pools_id: 'ap-southeast-2_ASIzjZWgd',
    aws_user_pools_web_client_id: '7g7qjbblg84fa8sq3n73en014q'
  };
  
  export default awsmobile;
  